// redux/store.ts
import { configureStore } from '@reduxjs/toolkit';
import { ThunkAction, Action } from '@reduxjs/toolkit';
import cartReducer from './features/cart';
import userReducer from './features/userSlice';
import couponReducer from './features/token';
import wishlistReducer from './features/wishlist';
import searchReducer from './features/search/searchSlice'; // Add this import
import settingsReducer from './features/settingsSlice'; // Add settings reducer

export const makeStore = () => {
  return configureStore({
    reducer: {
      user: userReducer,
      cart: cartReducer,
      coupon: couponReducer,
      wishlist: wishlistReducer,
      search: searchReducer, // Add search reducer
      settings: settingsReducer, // Add settings reducer
    },
  });
};

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
